import { z } from 'zod';

import { zodTimeStamp } from '@/utils/zodUtils';

export const BROADCAST_BODY_MAX_LENGTH = 160;

export const BroadcastCampaignStatus = z.enum([
  'pending',
  'sending',
  'completed',
  'failed',
]);

export const BroadcastPreviewRequestSchema = z.object({
  location_id: z.string().min(1),
  block_face_id: z.string().uuid().optional(),
});

export const BroadcastPreviewResponseSchema = z.object({
  recipient_count: z.number().int().nonnegative(),
  skipped_count: z.number().int().nonnegative(),
  sample_phones: z.array(z.string()),
});

export const BroadcastCampaignSchema = z.object({
  id: z.string().uuid(),
  location_id: z.string().min(1),
  block_face_id: z.string().uuid().nullish(),
  body: z.string().min(1).max(BROADCAST_BODY_MAX_LENGTH),
  status: BroadcastCampaignStatus,
  recipient_count: z.number().int().nonnegative(),
  delivered_count: z.number().int().nonnegative(),
  failed_count: z.number().int().nonnegative(),
  created_by_user_id: z.string(),
  created_at: zodTimeStamp,
});

export const BroadcastListResponseSchema = z.array(BroadcastCampaignSchema);

export const BroadcastComposeSchema = z.object({
  location_id: z.string().min(1),
  block_face_id: z.string().uuid().optional(),
  body: z
    .string()
    .min(1)
    .max(BROADCAST_BODY_MAX_LENGTH)
    .refine((s) => !s.includes('\0'), {
      message: 'Body cannot contain null bytes',
    }),
});

const blockfaceLabelSchema = z.object({
  block_face_id: z.string().uuid().nullish(),
  id: z.string().uuid().nullish(),
  blockface_label: z.string().nullable().optional(),
  label: z.string().nullable().optional(),
  blockface_address: z.string().nullable().optional(),
  address: z.string().nullable().optional(),
});

export const BroadcastBlockfaceListSchema = z.array(blockfaceLabelSchema);

export type BroadcastBlockfaceLabel = z.infer<typeof blockfaceLabelSchema>;

export type BroadcastCampaignStatusT = z.infer<typeof BroadcastCampaignStatus>;
export type BroadcastCampaign = z.infer<typeof BroadcastCampaignSchema>;
export type BroadcastPreviewRequest = z.infer<
  typeof BroadcastPreviewRequestSchema
>;
export type BroadcastPreviewResponse = z.infer<
  typeof BroadcastPreviewResponseSchema
>;
export type BroadcastCompose = z.infer<typeof BroadcastComposeSchema>;
export type BroadcastListResponse = z.infer<typeof BroadcastListResponseSchema>;
